"use strict";

class StationSettingsApplicationsOverviewCtrl {
    constructor($rootScope, $http, $mdToast, $mdDialog, $scope, $state, widgets) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$mdDialog = $mdDialog;
        this.$state = $state;
        this.widgets = widgets;

        this.fetch();

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = true;
    }

    fetch() {
        this.$http.get('/applications').then((response) => {
            this.applications = response.data;
        })
    }

    openApplication(application) {
        this.$state.go('stationsettings.applications.manage.edit', {applicationId: application.id});
    }

    addApplication() {
        this.$mdDialog.show({
            controller: 'ApplicationUploadDialogCtrl',
            templateUrl: "applicationUploadDialog.ngTemplate",
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: true
        }).then(() => {
            this.fetch();
        });
    }

    checkActiveApplication(id) {
        return this.$state.params.applicationId == id;
    }

    destroyApplication(application) {
        this.$mdDialog.show({
            controller: 'ConfirmDialogCtrl',
            templateUrl: "confirmDialog.ngTemplate",

            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: true
        }).then(() => {
            this.$http.delete('applications/' + application.id).then((response) => {
                if (response.status == 204) {
                    this.$rootScope.$broadcast('applicationsSaved');
                    this.widgets.reloadWidgetsData();
                    delete this.applications[application.id];
                    this.$state.go('stationsettings.applications.manage');
                }
                this.fetch();
            })
        });
    }
}

StationSettingsApplicationsOverviewCtrl.$inject = [
    '$rootScope',
    '$http',
    '$mdToast',
    '$mdDialog',
    '$scope',
    '$state',
    'widgets'
];

module.exports = StationSettingsApplicationsOverviewCtrl;
